<template>
  <div class="mb-4">
    <div class="mb-3">
      <button class="btn btn-info btn-icon mw" @click="sendRequest">
        {{ "update_status" | setText("Обновить статус") }}
      </button>
    </div>
    <div v-if="$store.state.user.is_root">
      <button class="btn btn-dager btn-icon mw" @click="cancelRequest">
        {{ "cancel_order" | setText("Отменить заявку") }}
      </button>
    </div>
  </div>
</template>
<script>
import { errorNotify } from "@/plugins/functions";

export default {
  methods: {
    async sendRequest() {
      const url = `${this.currentRequest.service.api_endpoint_url}v1/order/track&id=${this.data.exchange_id}`;
      const method = "post";
      let data = {};

      this.$loading(true);
      var instance = this.$http.create();
      delete instance.defaults.headers.common["Authorization"];
      delete instance.defaults.headers.common["bid"];
      delete instance.defaults.headers.common["localization"];
      delete instance.defaults.headers.common["shop"];
      delete instance.defaults.headers.common["device"];
      delete instance.defaults.headers.common["tab"];
      delete instance.defaults.headers.common["root"];
      delete instance.defaults.headers.common["version"];
      const config = {
        method: method,
        url: url,
        data: data,
        headers: {
          common: {
            Authorization: "Bearer " + this.currentRequest.service.api_token,
          },
        },
      };
      //REQUEST
      return instance(config)
        .then((response) => {
          this.$loading(false);
          const responseData = response.data;

          let data = {
            exchange_status_id: responseData.status.id,
          };

          if (responseData.status.id == 6) {
            data = {
              status: "received",
              exchange_status_id: responseData.status.id,
              service_request: {
                state: "done",
                service: "bts",
                response: JSON.stringify(responseData),
                body: JSON.stringify(data),
              },
            };
          } else if (
            responseData.status.id == 0 ||
            responseData.status.id == 7
          ) {
            data["status"] = "cancel";
          } else if (
            responseData.status.id == 5 ||
            responseData.status.id == 2
          ) {
            data["status"] = "done";
          } else if (responseData.status.id == 1) {
            data["status"] = "sent";
          }

          let message = "";

          if (responseData.status.id == this.data.exchange_status_id) {
            message = "Статус партнера не изменился";
          } else {
            message = "Статус партнера обновился";
          }

          this.$notify({
            title: "Статус партнера",
            message: message,
            icon: "ti-close",
            horizontalAlign: "right",
            verticalAlign: "top",
          });

          this.$emit("input", data);

          return responseData;
        })
        .catch((error) => {
          this.$loading(false);
          return errorNotify(error, this.notify);
        })
        .finally(() => {});
    },

    async cancelRequest() {
      const url = `${this.currentRequest.service.api_endpoint_url}v1/order/cancel&id=${this.data.exchange_id}`;
      const method = "post";
      let data = {};
      this.$dialog
        .confirm(`Вы уверены, что хотите отменить заказ?`, {
          okText: "Да | To'g'ri",
          cancelText: "Нет | Yo'q",
        })
        .then(() => {
          this.$loading(true);
          var instance = this.$http.create();
          delete instance.defaults.headers.common["Authorization"];
          delete instance.defaults.headers.common["bid"];
          delete instance.defaults.headers.common["localization"];
          delete instance.defaults.headers.common["shop"];
          delete instance.defaults.headers.common["device"];
          delete instance.defaults.headers.common["tab"];
          delete instance.defaults.headers.common["root"];
          delete instance.defaults.headers.common["version"];
          const config = {
            method: method,
            url: url,
            data: data,
            headers: {
              common: {
                Authorization:
                  "Bearer " + this.currentRequest.service.api_token,
              },
            },
          };
          //REQUEST
          return instance(config)
            .then((response) => {
              this.$loading(false);
              const responseData = response.data;
              this.$emit("input", {
                delete: true,
              });
              return responseData;
            })
            .catch((error) => {
              this.$loading(false);
              return errorNotify(error, this.notify);
            })
            .finally(() => {});
        })
        .catch(() => {});
    },
  },
  props: ["value", "data", "currentRequest"],
};
</script>
<style>
</style>
 